import { ScoreType } from "@app/common/dialog-add-score/dialog-add-score.model";
import {
  TagDto,
  ResponseStatus,
} from "src/swagger/api.client.generated";
import { UserSettingType } from "@app/pages/settings/user-setting-type.enum";

export class ScoreItem {
  constructor(
    name: string,
    stars: number,
    update: boolean = false,
    index: number = null,
    selectedTags: TagDto[] = []
  ) {
    this.name = name;
    this.stars = stars;
    this.update = update;
    this.index = index;
    this.selectedTags = selectedTags;
  }

  name: string;
  stars: number;
  update: boolean = false;
  index: number;
  selectedTags: TagDto[] = [];
}

export class LoadPreviousScores {
  scoreType: ScoreType;
  newScoreSession: boolean;
  showPrompt: boolean;
  loadPrevious: boolean;
}

/**
 * Represents a single user setting value
 */
export class UserSettingItem {
  name: string;
  userGuid: string;
  value: string;
  type: UserSettingType;

  constructor(data?: Partial<UserSettingItem>) {
    if (data) {
      this.name = data.name;
      this.userGuid = data.userGuid;
      this.value = data.value;
      this.type = data.type;
    }
  }
}

/**
 * Response transport for a single user setting item
 */
export class ResponseTransportOfUserSettingItem {
  status: ResponseStatus;
  result?: UserSettingItem;
  error?: any;

  constructor(data?: Partial<ResponseTransportOfUserSettingItem>) {
    if (data) {
      this.status = data.status;
      this.result = data.result ? new UserSettingItem(data.result) : undefined;
      this.error = data.error;
    }
  }
}
